<template>
  <div id="overview-index">
    <!-- 后台概览界面 -->
    <div class="left">
      <div class="icon">
        <div class="ii">
          <img :src="userData.icon" alt="" />
          <div class="choose">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              multiple
              :data="{
                title: '用户头像',
              }"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
            >
              <div class="mb">选择文件</div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="line">{{ userData.name }}</div>
      <div class="line">职业技能等级:{{ userData.leverl }}</div>
      <div class="line">学历:{{ userData.education }}</div>
      <div class="line">入伍年月:{{ userData.armyDate }}</div>
      <!-- <div class="line"><div class="title-but">个人中心</div></div> -->
    </div>
    <div class="content">
      <div class="img">
        <img src="../../../assets/img/onlinetest.png" alt="" />
      </div>
      <div class="title">{{ examTitle }}</div>
      <div class="time">考试时间: {{ examTme }}</div>
      <div class="but"><div class="add_but" @click="goto">查看详情</div></div>
    </div>
    <div class="right"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      examTitle: "2023-2024学年第一学期期末考试",
      examTme: "2023-06-19 12:20:00",
      userData: {},
      action: this.$baseurl + "/uploadFile",
      headers: {
        token: "",
      },
    };
  },
  methods: {
    async getUserDetails() {
      try {
        let userData = JSON.parse(sessionStorage.getItem("userData"));
        let resultData = await this.$request({
          url: "/user/getUserDetails",
          method: "post",
          data: { id: userData.userId },
        });
        this.userData = resultData;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getRecentlyExam() {
      try {
        let userData = JSON.parse(sessionStorage.getItem("userData"));
        let resultData = await this.$request({
          url: "/exam/getRecentlyExam",
          method: "post",
          data: { uId: userData.userId },
        });
        if (resultData.id != "") {
          this.examTitle = resultData.name;
          this.examTme = resultData.time;
        } else {
          this.examTitle = "暂无考试计划!";
          this.examTme = "";
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: "warning",
          duration: 1000,
        });
      }
    },
    /**
     * 导入前文件格式判断  只能上传exel格式数据
     */
    beforeAvatarUpload(file) {
      console.log(file.type);
      let isJPG = false;
      let errorString = "";
      isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";
      errorString = "图像仅支持.png、.jpg、.jpeg格式!!!";

      if (!isJPG) {
        this.$message.error(errorString);
      }
      return isJPG;
    },
    /**
     * 模板上传成功
     */
    async handleAvatarSuccess(response, file, fileList) {
      console.log(response);
      try {
        if (response.code == "200") {
          let requestData = {
            id: JSON.parse(sessionStorage.getItem("userData")).userId,
            icon: response.result.path,
          };
          let resultData = await this.$request({
            url: "/user/updateIcon",
            method: "post",
            data: requestData,
          });
          this.$message.success("图像上传成功!");
          this.userData.icon = response.result.path;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 跳转至考试中心
    goto() {
      this.$router.push("/exam/list");
    },
  },
  async mounted() {
    await this.getUserDetails();
    await this.getRecentlyExam();
  },
};
</script>

<style lang="less" scoped>
#overview-index {
  width: 100%;
  // height: 100%;
  display: flex;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  > .left {
    width: 15%;
    height: auto;
    background-color: #fcfcfc;
    display: flex;
    flex-direction: column;
    > .icon {
      width: 100%;
      height: 120px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      > .ii {
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .choose {
          opacity: 0;
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.3s;
          .mb {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background-color: #00000054;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
          }
        }
        &:hover .choose {
          opacity: 1;
        }
      }
    }
    > .line {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      > .title-but {
        width: auto;
        font-size: 13px;
        border: 1px solid #333;
        font-weight: normal;
        padding: 4px 19px;
        box-sizing: border-box;
        border-radius: 3px;
        cursor: pointer;
      }
    }
  }
  > .content {
    height: auto;
    width: 40%;
    background-color: #f7f7f7;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 100px;
    box-sizing: border-box;
    > .img {
      width: 100%;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    > .title {
      width: 100%;
      height: auto;
      display: flex;
      font-size: 20px;
      align-items: center;
      justify-content: center;
      font-weight: bold;
    }
    > .time {
      width: 100%;
      height: auto;
      display: flex;
      font-size: 17px;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }
    > .but {
      width: 40%;
      margin-top: 20px;
    }
  }
  // > .right {
  //   width: 15%;
  //   height: auto;
  //   background-color: #f7f7f7;
  //   margin-left: 20px;
  // }
}
</style>